import { render, staticRenderFns } from "./channels.vue?vue&type=template&id=70573474&"
import script from "./channels.vue?vue&type=script&lang=js&"
export * from "./channels.vue?vue&type=script&lang=js&"
import style0 from "./channels.vue?vue&type=style&index=0&id=70573474&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports